import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const TimeLogModal = ({ isOpen, onClose, task, onSubmit }) => {
  const [timeData, setTimeData] = useState({
    hours: '',
    minutes: '',
    description: '',
    category: 'development'
  });

  const categoryOptions = [
    { value: 'development', label: 'Development' },
    { value: 'testing', label: 'Testing' },
    { value: 'documentation', label: 'Documentation' },
    { value: 'meeting', label: 'Meeting' },
    { value: 'research', label: 'Research' },
    { value: 'review', label: 'Review' },
    { value: 'other', label: 'Other' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    const totalMinutes = parseInt(timeData?.hours || 0) * 60 + parseInt(timeData?.minutes || 0);
    
    if (totalMinutes === 0) {
      alert('Please enter a valid time duration');
      return;
    }

    onSubmit({
      taskId: task?.id,
      duration: totalMinutes,
      description: timeData?.description,
      category: timeData?.category,
      timestamp: new Date()?.toISOString()
    });

    setTimeData({
      hours: '',
      minutes: '',
      description: '',
      category: 'development'
    });
    onClose();
  };

  const handleInputChange = (field, value) => {
    setTimeData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-400 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-md card-shadow">
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground">Log Time</h3>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClose}
          />
        </div>

        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          <div className="bg-muted/50 rounded-lg p-3">
            <h4 className="text-sm font-medium text-foreground mb-1">{task?.title}</h4>
            <p className="text-xs text-muted-foreground">{task?.project}</p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Hours"
              type="number"
              min="0"
              max="24"
              placeholder="0"
              value={timeData?.hours}
              onChange={(e) => handleInputChange('hours', e?.target?.value)}
            />
            <Input
              label="Minutes"
              type="number"
              min="0"
              max="59"
              placeholder="0"
              value={timeData?.minutes}
              onChange={(e) => handleInputChange('minutes', e?.target?.value)}
            />
          </div>

          <Select
            label="Category"
            options={categoryOptions}
            value={timeData?.category}
            onChange={(value) => handleInputChange('category', value)}
          />

          <Input
            label="Description"
            type="text"
            placeholder="What did you work on?"
            value={timeData?.description}
            onChange={(e) => handleInputChange('description', e?.target?.value)}
            description="Optional: Describe the work completed"
          />

          <div className="flex items-center justify-end space-x-3 pt-4 border-t border-border">
            <Button
              variant="outline"
              onClick={onClose}
              type="button"
            >
              Cancel
            </Button>
            <Button
              variant="default"
              type="submit"
              iconName="Clock"
              iconPosition="left"
            >
              Log Time
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TimeLogModal;